import { Box, IconButton, Input, Switch } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { CustomDataGrid } from '../../../common/components/Table/CustomDataGrid';
import httpCommon from '../../../http-common';
import CustomExportButton from '../../../common/components/Table/CustomExportButton';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { useGridApiRef } from '@mui/x-data-grid';
import { v4 } from "uuid";
import ContainedButton from '../../../common/components/Buttons/ContainedButton';
import SnackbarWithMessage from '../../../common/components/Snackbars/SnackbarWithMessage';
import { FileUploaderRipik } from '../../HomePage/components/FileUploaderRipik';
import { mixpanelTrackTabsButton } from '../../../mixPanelFunctions/mixPanelFunctions';

const postSLA = async (sla_data) => {
  const data = JSON.stringify({ ...sla_data });
  try {
    const response = await httpCommon.post(`/v1/qc/sla_data`, data);
    const result = response.data;
    if (result?.status === "success") return true;
    else throw new Error(`${result.message}`);
  } catch (error) {
    console.log({ error });
    return error;
    // return ;
  }
};

const deleteSLA = async (sla_body) => {
  const data = JSON.stringify({ ...sla_body });
  try {
    const response = await httpCommon.delete(`/v1/qc/sla_data`, { data });
    const result = response.data;
    if (result?.status === "success") return true;
    else throw new Error(`SLA couldn't be deleted, response message:${result.message}`);
  } catch (error) {
    console.log({ error });
    return false;
  }
};

const SLACell = ({ value, id, handle_change, type = "text" }) => {
  return <Input
    // sx={{ width: "100%" }}
    value={value}
    id={id}
    onChange={(e) => {
      handle_change(e);
    }}
    onKeyDown={(e) => {
      e.stopPropagation();
    }}
    type={type} />;
};

const SLADashboard = () => {
  const [rows, set_rows] = useState([]);

  const fetch_data = async () => {
    try {
      const response = await httpCommon.get(`/v1/qc/sla_data`);
      const result = response.data.data.map((item) => ({
        ...item,
        id: item._id
      }));
      return result;
    } catch (error) {
      console.log({ error });
    }
  };

  const initialize_data = async () => {
    const data = await fetch_data();
    set_rows(data);
  };

  useEffect(() => {
    initialize_data();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const apiRef = useGridApiRef();

  const handleDeleteSLA = async (params) => {
    // console.log({ params });
    const {
      sample_type
    } = params.row;
    const response = await deleteSLA({
      sample_type
    });
    if (response === true) {
      const row_id = params.row.id;
      apiRef.current.updateRows([{
        id: row_id,
        // _action: "delete"
        is_disabled: !params?.row?.is_disabled
      }]);
    }
    else {
      console.log("probably this SLA doesn't exist, reloading the data for you.");
      initialize_data();
    }
  };
  const columns = [
    {
      "field": "sample_type",
      headerName: "Sample Type",
      flex: 1,
      // width: 200,
      editable: false,
      align: "center",
      headerAlign: "center"
    },
    {
      "field": "SLA",
      headerName: "SLA",
      type: "number",
      flex: 1,
      // width: 200,
      editable: true,
      align: "center",
      headerAlign: "center"
    },
    {
      field: 'is_disabled',
      headerName: 'Enable',
      width: 100,
      renderCell: (params) => {
        // console.log({ params });
        return (
          <Box sx={{ width: "100%" }}>
            <div style={{ position: 'sticky', right: 0, zIndex: 1 }}>
              <Switch checked={!params?.row?.is_disabled} onClick={() => {
                handleDeleteSLA(params);
              }} />
              {/* <IconButton onClick={() => handleDeleteSLA(params)}>
                <DeleteIcon style={{ color: '#ff5722' }} />
              </IconButton> */}
            </div>
          </Box>
        );
      },
    },
  ];

  const saveOnServer = async (updatedRow) => {
    const { _id, sample_type, ...update_fields } = updatedRow;

    delete update_fields.id;

    const data = JSON.stringify({
      sample_type,
      update_fields
    });
    const response = await httpCommon.patch(`/v1/qc/sla_data`, data);
    const result = response.data.status;
    if (result === "success") return true;
    else return false;
  };

  const [new_dg_row, set_new_dg_row] = useState([{
    "id": v4(),
    "sample_type": "",
    "SLA": "",
  }]);

  const handle_change_new_row_data = (e) => {
    const { id, value } = e.target;
    const old = { ...new_dg_row[0] };
    old[id] = value;
    set_new_dg_row([{ ...old }]);
  };

  const new_dg_columns = [
    {
      "field": "sample_type",
      headerName: "Sample Type",
      flex: 1,
      // width: 200,
      editable: false,
      renderCell: () => {
        return <SLACell value={new_dg_row[0]['sample_type']} handle_change={handle_change_new_row_data} id={"sample_type"} />;
      },
      align: "center",
      headerAlign: "center",
      "cellClassName": "border hover:bg-white",
    },
    {
      "field": "SLA",
      headerName: "SLA",
      flex: 1,
      // width: 200,
      editable: false,
      renderCell: () => {
        return <SLACell value={new_dg_row[0]['SLA']} handle_change={handle_change_new_row_data} id={"SLA"} type='number' />;
      },
      align: "center",
      headerAlign: "center",
      "cellClassName": "border hover:bg-white",
    },
    {
      "field": "add_row",
      "headerName": "",
      "editable": false,
      renderCell: () => {
        const handle_add = async () => {
          const row = new_dg_row[0];
          const vals = Object.values(row);
          for (let val of vals) {
            if (val === "" || val === null) {
              alert("Please enter all the fields before adding the SLA.");
              return;
            }
          }
          const {
            sample_type,
            SLA,
          } = row;
          const sla_data = { sample_type, add_fields: { SLA } };
          const response = await postSLA(sla_data);
          if (response === true) {
            apiRef.current.updateRows([{ ...row }]);
            set_new_dg_row(prev => ([{
              ...prev[0],
              sample_type: "",
              SLA: "",
              id: v4()
            }]));
            // alert("updated");
          }
          else {
            // alert("couldn't update due to some error at the backend.");
            alert(response);
          }
        };
        return <ContainedButton handleClick={handle_add}>Add</ContainedButton>;
      }
    }
  ];

  const [open_snackbar_with_message, set_open_snackbar_with_message] = useState({
    open: false,
    message: "",
    severity: "info"
  });

  const [file, set_file] = useState(null);

  const handle_file_upload = async (uploaded_file) => {
    try {
      const data = new FormData();
      data.append("excel_file", uploaded_file);
      // console.log([...data.entries()]);
      const response = await httpCommon.post(`/v1/qc/upload_mastersheet/sla_data/`, data, {
        "headers": {
          "Content-Type": "multipart/form-data"
        }
      });
      const result = response.data;
      mixpanelTrackTabsButton("SLADashboard","file upload","master-sheet") // tracking tab button
      console.log({ result });
      if (result.status === "error") {
        set_open_snackbar_with_message({
          message: result.message,
          open: true,
          severity: "error"
        });
      }
      else if (result.status === "success") {
        set_open_snackbar_with_message({
          message: `Data uploaded successfully!`,
          open: true,
          severity: "success"
        });
        initialize_data();
      }
    } catch (error) {
      console.log({ error });
    }
  };

  return (
    <Box>
      <Box className="mb-4">
        <SnackbarWithMessage {...open_snackbar_with_message} onClose={() => {
          set_open_snackbar_with_message({
            open: false,
            message: "",
            severity: "info"
          });
        }} />
        <Box className="flex justify-end items-center">
          <FileUploaderRipik file={file} file_update_function={(uploaded_file) => {
            set_file(uploaded_file);
            console.log(uploaded_file);
            handle_file_upload(uploaded_file);
          }} upload_message={`Upload File Here`} />
        </Box>
        <CustomDataGrid
          apiRef={apiRef}
          columns={columns}
          rows={rows}
          sx={{
            height: "400px",
            // width: "500px"
          }}
          hideFooter
          disableRowSelectionOnClick
          slots={{
            toolbar: CustomExportButton
          }}
          processRowUpdate={async (updatedRow, originalRow) => {
            const result = await saveOnServer(updatedRow);
            if (result) return updatedRow;
            else return originalRow;
            // console.log({ updatedRow, originalRow });
            // return updatedRow;
          }}
        />
      </Box>
      <Box>
        <CustomDataGrid
          columns={new_dg_columns}
          rows={new_dg_row}
          hideFooter
        />
      </Box>
    </Box>
  );
};

export default SLADashboard;